
const _getStatusBarHeight = () => {
    if( window?.webkit?.messageHandlers?.getStatusBarHeight) {
        window?.webkit.messageHandlers.getStatusBarHeight.postMessage('')
    }
}
export default _getStatusBarHeight